module.exports = __webpack_public_path__ + "static/img/SSDHighlightVideo_Tina_Still.e791b98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/SSDHighlightVideo_Tina_Still.jpg
// module id = xyyK
// module chunks = 0